<template>
  <b-modal
    id="modalDeviceInfo"
    v-model="localIsActive"
    centered
    no-close-on-esc
    no-close-on-backdrop
    size="lg"
    header-bg-variant="dark"
    header-text-variant="light"
    @hidden="closeModal"
  >
    <template #modal-title> {{ $t("hanwha_dvr.network_info") }} {{ hanwhaDvr.name }}</template>
    <div class="text-danger" v-if="showNoDataMessage && !isNetworkInfoLoading">
      {{ $t('grid.widgets.alarms.table.no_data') }}
    </div>
    <b-row v-if="networkInfo">
      <div
        class="card border w-100 mb-1"
        v-for="(info, index) in networkInfo.NetworkInterfaces"
        :key="index">
        <div
          class="d-flex justify-content-between networkCollapseItem"
          v-b-toggle="'collapse-'+networkInfo.HostName+index">
          <span class="ml-1">{{ info.InterfaceName }}</span>
          <feather-icon
            class="mr-1"
            icon="ChevronDownIcon"
            size="20"
          />
        </div>
        <b-collapse :visible="index === 0" :id="'collapse-'+networkInfo.HostName+index">
          <div class="networkInfoContainer">
            <div class="d-flex networkInfoItem" v-for="(detail, key) in networkInfo.NetworkInterfaces[index]" :key="key">
              <div class="diskInfoDetailKey">{{ key }}:</div>
              <div class="diskInfoDetailItem">{{ detail }}</div>
            </div>
          </div>
        </b-collapse>
      </div>
    </b-row>
    <b-row v-if="!networkInfo && isNetworkInfoLoading">
      <div class="d-flex flex-column">
        <SkeletonLoading :width="284" :height="37"/>
        <SkeletonLoading :width="284" :height="37"/>
      </div>
    </b-row>
  </b-modal>
</template>
    
<script>
import { BModal, BSpinner, BCollapse } from "bootstrap-vue";
import { computed, ref } from "@vue/composition-api";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import { useNetworkInfo } from "./useNetworkInfo";

export default {
  components: {
    BModal,
    BSpinner,
    SkeletonLoading,
    BCollapse
  },
  props: {
    hanwhaDvr: { type: Object, required: true },
    isModalNetworkActive: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const isModalActive = ref(false);
    const { isNetworkInfoLoading, showNoDataMessage , networkInfo, getNetworkInfo } = useNetworkInfo(props.hanwhaDvr)

    const localIsActive = computed({
      get() {
        return props.isModalNetworkActive;
      },
      set(value) {
        emit("update:isActive", value);
      },
    });

    const closeModal = () => {
      emit('close-modal');
    };
    getNetworkInfo()

    return {
      isModalActive,
      localIsActive,
      isNetworkInfoLoading,
      showNoDataMessage,
      networkInfo,
      closeModal
    };
  },
};
</script>

<style lang="scss" scoped>
.networkInfoContainer {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px; /* space between items */
  padding: 16px;
}
.networkInfoItem {
  width: 250px;
}
.networkCollapseItem {
  padding: 5px;
  background-color: rgb(239 239 239) ;
}
.diskInfoDetailKey {
  width: 140px;
  font-weight: 100;
  color: #a5a5a5;
}
.diskInfoDetailItem {
  color: #393735;
}
.dark-layout {
  .diskInfoDetailKey {
    color: #a5a5a5;
  }
  .diskInfoDetailItem {
    color: #fff;
  }
  .networkCollapseItem {
    background-color: #0c0c0c ;
  }
}
</style>